import { render, staticRenderFns } from "./mopiCenter.vue?vue&type=template&id=0b31ed76&scoped=true&"
import script from "./mopiCenter.vue?vue&type=script&lang=js&"
export * from "./mopiCenter.vue?vue&type=script&lang=js&"
import style0 from "./mopiCenter.vue?vue&type=style&index=0&id=0b31ed76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b31ed76",
  null
  
)

export default component.exports